import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TRANSLATIONS, INTERNAL_TRANSLATIONS, LOGIN_STATUS as loginStat } from '../../../utils/constant.utils';
import { translationAction } from '../../../store/external/translation-reducer/translation.reducer'

class Translation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            translation: ''
        };
    }

    componentDidMount() {
        var languageLocale = JSON.parse(sessionStorage.getItem('User'))?.Employee.LanguageLocale;
        var locale = languageLocale ? languageLocale : this.props.locale === null ? 'en_US' : this.props.locale;

        this._updateTranslation(this.props.translationKey, locale);
    }

    componentWillReceiveProps(nextProps) {
        // update the translation if one of the props will change
        if (this.props.translationKey !== nextProps.translationKey || this.props.locale !== nextProps.locale) {
            this._updateTranslation(nextProps.translationKey, nextProps.locale);
        }
    }

    onChangeState = (value, translationKey) => this.props.onChangeTranslation(value, translationKey);

    _updateTranslation(translationKey, activeLanguageCode) {
        if (translationKey && activeLanguageCode) {
            try {
                this.setState({
                    translation: sessionStorage.getItem('logInStatus') == loginStat.internal
                        ? INTERNAL_TRANSLATIONS[activeLanguageCode][translationKey]
                        : TRANSLATIONS[activeLanguageCode][translationKey]
                }, () => {
                    if (this.props.getOnlyText == true) {
                        this.onChangeState(this.state.translation, translationKey);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        }
    };

    render() {
        if (!this.state.translation || this.state.translation === '') return null;
        return (
            <>{this.props.getOnlyText === true ? '': this.state.translation}</>
        );
    }
}


export default connect(
    state => state.translation,
    dispatch => bindActionCreators(translationAction, dispatch),
    null,
    {
        pure: false
    }
)(Translation);
